import * as React from 'react';

import {ActionCard} from 'shells/action-card/action-card';
// @ts-expect-error - imported from .js/.jsx file
import {ExternalLinkIcon} from 'shells/icon/svg/external-link-icon';

import type {ExternalMeetingForModalFragment as ExternalMeeting} from 'nutshell-graphql-types';

import {useExternalMeetingRecordingDelete} from '../../graphql/hooks';

import {CONFIRMATION_QUESTION} from './consts';

type Props = {
    externalMeeting: ExternalMeeting;
};

export function Video(props: Props) {
    const {externalMeeting} = props;

    const {externalMeetingRecordingDelete} = useExternalMeetingRecordingDelete();

    const handleLinkVideo = () => {
        if (externalMeeting.recordingUrl) {
            window.open(externalMeeting.recordingUrl, '_blank');
        }
    };

    const handleRemoveVideo = () => {
        externalMeetingRecordingDelete({
            externalMeeting: externalMeeting.id,
        });
    };

    return (
        <ActionCard
            actionTitle='Watch recording'
            actionIcon={ExternalLinkIcon}
            onAction={handleLinkVideo}
            onRemove={handleRemoveVideo}
            closeButtonTooltip='Remove'
            confirmationQuestion={CONFIRMATION_QUESTION}
        />
    );
}
